import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const FixedPostInspectionService = {
    apply: async (payload) => axios.post(`${API_URL}/reports/fixed-post-inspection/apply`, payload).then(({data}) => data.data).catch((err) => { throw err })
};

export default FixedPostInspectionService;